import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Skeleton from 'react-loading-skeleton'
import SkeletonTable from '../../../common/skeleton-table'
import Y from '../../../y18n'
import Moment from 'moment'
import Styles from '../../../common/styles'
import EventHistory from '../components/event-history'
import * as subscriptionActions from '../../../store/subscriptions-admin/subscription'

const mapStateToProps = state => ({
  subscription: state.subscriptionsAdmin.subscription
})

const mapDispatchToProps = dispatch => ({
  subscriptionActions: bindActionCreators(subscriptionActions, dispatch)
})

class SubscriptionSummary extends Component {
  state = {
    status: null,
    smsStatus: null,
    statusLoading: false,
    smsStatusLoading: false
  }

  componentDidMount () {
    const { id, subscription, subscriptionActions } = this.props
    subscriptionActions.getSubscriptionDetails(id).then(res => {
      if (subscription.detailedSubscription) {
        this.setState({
          status: subscription.detailedSubscription.status === 'Active',
          smsStatus: subscription.detailedSubscription.smsStatus === 'Active'
        })
      }
    })
  }

  switchChanged = name => e => {
    e.preventDefault()
    let loadingKey = name === 'status' ? 'statusLoading' : 'smsStatusLoading'
    this.setState({ [name]: e.target.checked, [loadingKey]: true })
    this.props.subscriptionActions.changeStatus(name, e.target.checked).then(res => {
      this.setState({ [loadingKey]: false })
    })
  }

  render () {
    const { subscription, classes } = this.props
    return (
      <div>
        <div className={classes.textRow}>
          <Typography variant='title'>
            {Y`Subscription summary`}
          </Typography>
          <Typography
            variant='body2'
            className={classes.themeLink}
            title={Y`Edit subscription`}
            onClick={() => this.props.subscriptionActions.setActive(subscription.detailedSubscription, true)}
          >
            {Y`Edit subscription`}
          </Typography>
          {subscription.loading || !subscription.detailedSubscription ? 
          <Typography
          variant='body2'
        >
          <Skeleton count={1} />
        </Typography>  
         :
         subscription.detailedSubscription.isDeleted ? 
         <Typography
         variant='body2'
         style={{color: 'red' }}
       >
         {Y`Subscription deleted by user.`}
       </Typography> : ''
         }
        </div>
        <div className={classes.flexRow}>
          <Paper className={classes.flexItemLeft}>
            <div className={classes.tableWrapper}>
              <Table className={'striped'}>
                {subscription.loading || !subscription.detailedSubscription
                  ? <TableBody><SkeletonTable rows={7} cols={2} /></TableBody>
                  : this.renderLeftTable()}
              </Table>
            </div>
          </Paper>
          <Paper className={classes.flexItemRight}>
            <div className={classes.tableWrapper}>
              <Table className={'striped'}>
                {subscription.loading || !subscription.detailedSubscription
                  ? <TableBody><SkeletonTable rows={7} cols={2} /></TableBody>
                  : this.renderRightTable()}
              </Table>
            </div>
          </Paper>
        </div>
        <div style={{ marginTop: '40px' }}>
          <EventHistory
            subscription={subscription}
            statusLoading={this.state.statusLoading || this.state.smsStatusLoading}
          />
        </div>
      </div>
    )
  }

  renderLeftTable () {
    const { subscription } = this.props
    return (
      <TableBody>
        <TableRow>
          <TableCell>
            <strong>{Y`IMSI`}:</strong>
          </TableCell>
          <TableCell>
            {subscription.detailedSubscription.imsi}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <strong>{Y`MSISDN`}:</strong>
          </TableCell>
          <TableCell>
            {subscription.detailedSubscription.msisdn}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <strong>{Y`ICC`}:</strong>
          </TableCell>
          <TableCell>
            {subscription.detailedSubscription.icc}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <strong>{Y`User`}:</strong>
          </TableCell>
          <TableCell>
            {subscription.detailedSubscription.customerName}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <strong>{Y`Email`}:</strong>
          </TableCell>
          <TableCell>
            {subscription.detailedSubscription.email}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <strong>{Y`Status`}:</strong>
          </TableCell>
          <TableCell>
            <span
              style={{
                fontWeight: 'bold',
                color: subscription.detailedSubscription.status === 'Active' ? 'green' : 'red'
              }}
            >{Y`${subscription.detailedSubscription.status}`}</span>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <strong>{Y`SMS status`}:</strong>
          </TableCell>
          <TableCell>
            <span
              style={{
                fontWeight: 'bold',
                color: subscription.detailedSubscription.smsStatus === 'Active' ? 'green' : 'red'
              }}
            >{Y`${subscription.detailedSubscription.smsStatus}`}</span>
          </TableCell>
        </TableRow>
      </TableBody>
    )
  }

  renderRightTable () {
    const { subscription } = this.props
    return (
      <TableBody>
        <TableRow>
          <TableCell>
            <strong>{Y`Subscription name`}:</strong>
          </TableCell>
          <TableCell>
            {subscription.detailedSubscription.name}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <strong>{Y`Product`}:</strong>
          </TableCell>
          <TableCell>
            {subscription.detailedSubscription.productName}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <strong>{Y`Data limit`} (MB):</strong>
          </TableCell>
          <TableCell>
            {subscription.detailedSubscription.dataLimitMb}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <strong>{Y`Remaining data`} (MB):</strong>
          </TableCell>
          <TableCell>
          {(subscription.detailedSubscription.dataUsed || 0.0 ).toFixed(0)} MB
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <strong>{Y`SMS limit`}:</strong>
          </TableCell>
          <TableCell>
            {subscription.detailedSubscription.smsLimit}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <strong>{Y`SMS used`} (%):</strong>
          </TableCell>
          <TableCell>
            {Math.min(100.00, subscription.detailedSubscription.smsUsed)}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <strong>{Y`Valid`}:</strong>
          </TableCell>
          <TableCell>
            {Moment(subscription.detailedSubscription.startDate).format('YYYY-MM-DD')}
            {' '}
            -
            {' '}
            {Moment(subscription.detailedSubscription.endDate).format('YYYY-MM-DD')}
          </TableCell>
        </TableRow>
      </TableBody>
    )
  }
}

SubscriptionSummary = connect(mapStateToProps, mapDispatchToProps)(SubscriptionSummary)
export default withStyles(Styles)(SubscriptionSummary)



// WEBPACK FOOTER //
// ./src/pages/subscription-details/containers/subscription-summary.js